import { API } from '../../../config';
import { errorHandler } from '../auth/errorAction';

export const unmountListOrganizer = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_ORGANIZER'})
}

export const unmountDetailOrganizer = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_ORGANIZER'})
}

export const unmountMasterOrganizer = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_ORGANIZER'})
}

export const listOrganizer = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_ORGANIZER' })
  return API.GET('/organizer/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_ORGANIZER_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_ORGANIZER_FAILED' }), 
    ))
  })
}

export const detailOrganizer = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_ORGANIZER' })
  const params = {
    'id': id
  }
  API.GET('/organizer/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_ORGANIZER_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_ORGANIZER_FAILED' }), 
      ))
    )
  })
}

export const masterOrganizer = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_ORGANIZER' })
  return API.GET('/organizer/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_ORGANIZER_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: null,
          total: null,
          perpage: null
        }
    }})
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_ORGANIZER_FAILED' }), 
    ))
  })
}

export const createOrganizer = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/organizer/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editOrganizer = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/organizer/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableOrganizer = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/organizer/enableUser', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableOrganizer = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/organizer/disableUser', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}